import { ThemeDefinition } from 'vuetify';

export const biology: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#61B876',
    'on-subject-original': '#FFFFFF',
    subject: '#328547',
    'on-subject': '#FFFFFF',
    primary: '#2C633A',
    'on-primary': '#FFFFFF',
    'primary-container': '#CAE7D1',
    'on-primary-container': '#132A19',
    secondary: '#495A4E',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D5DDD7',
    'on-secondary-container': '#1C221D',
    surface: '#F7FCF9',
    'on-surface': '#1D201E',
    'on-surface-medium': '#49504B',
    'on-surface-low': '#949E96',
    outline: '#79867C',
    'outline-variant': '#C9CFCB',
    'inverse-surface': '#24422B',
    'inverse-on-surface': '#EEF6F0',
    'inverse-primary': '#B9DFC2',
    'surface-dim': '#C2EBCC',
    'surface-bright': '#FBFEFC',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F0FAF2',
    'surface-container': '#E8F7EC',
    'surface-container-high': '#D9F2DF',
    'surface-container-highest': '#D1F0D9',
  },
};

export const biologyDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#61B877',
    'on-subject-original': '#F8FCF9',
    subject: '#81C692',
    'on-subject': '#132A19',
    primary: '#AEDABA',
    'on-primary': '#132A19',
    'primary-container': '#295B36',
    'on-primary-container': '#EDF7F0',
    secondary: '#C4D4C8',
    'on-secondary': '#1A231C',
    'secondary-container': '#415847',
    'on-secondary-container': '#F0F4F1',
    surface: '#101812',
    'on-surface': '#F2F3F2',
    'on-surface-medium': '#C9CFCB',
    'on-surface-low': '#79867C',
    outline: '#949E97',
    'outline-variant': '#616B64',
    'inverse-surface': '#DEEDE2',
    'inverse-on-surface': '#15281A',
    'inverse-primary': '#24422C',
    'surface-dim': '#0E1510',
    'surface-bright': '#2F4635',
    'surface-container-lowest': '#0C120E',
    'surface-container-low': '#141F17',
    'surface-container': '#1B281E',
    'surface-container-high': '#233427',
    'surface-container-highest': '#2D4333',
  },
};
